import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate,Link } from 'react-router-dom';
import Select from "react-select";
import {
  getIncidents as ongetIncidents,
  getServices as onGetServices,
  getPingMonitors as onGetPingMonitors,
  createComponentService as createComponentService,
  getComponents, getMappedAlerts,
  getTimeStampData, deleteComponentService, deleteIncident,
  getTimeStampDataForOneDay,
  getExternalComponents,
  getAWSHealthEvents,
  getOrganization as onGetOrganization, getPingMonitors, getMonitoringSystems
} from "../../store/actions";
import "./styles.scss"
import profileImg from "../../assets/images/profile.png";
import {
  format,
  subMonths,
  eachDayOfInterval,
  isFuture,
  isToday,
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  addDays,
  isSameMonth,
  parseISO,
  subDays,
  isWithinInterval,
  differenceInMinutes,
  startOfDay,
  endOfDay,
  isValid
} from 'date-fns';
import SideBar from "../../components/HorizontalLayout/Sidebar";
import {getLocalDateTime} from "../../helpers/component_helpers";
import {Col, Modal, ModalBody, ModalHeader, Row, UncontrolledTooltip} from "reactstrap";
import moment from "moment-timezone";
import OnUpdateProfilePicModal from "../Profile/OnUpdateProfilePicModal";

const StatusPageManagement = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedRange, setSelectedRange] = useState(90);
  const [currentEndpointId, setCurrentEndpointId] = useState(null);
  const [editEnabled, setEditEnabled] = useState({});
  const [expandedCards, setExpandedCards] = useState({});
  const [selectedService, setSelectedService] = useState(null);
  const [selectedEndpoint, setSelectedEndpoint] = useState(null);
  const [showComponentForm, setShowComponentForm] = useState(false);
  const [endpointOptions, setEndpointOptions] = useState([]);
  const [hoveredCalendarDay, setHoveredCalendarDay] = useState(null);
  const [endpointTimestamps, setEndpointTimestamps] = useState({});
  const [isLoading, setIsLoading] = useState({});
  const [fetchingEndpointId, setFetchingEndpointId] = useState(null);
  const [showDeleteComponentModal, setShowDeleteComponentModal] = useState(false);
  const [showDeleteIncidentModal, setShowDeleteIncidentModal] = useState(false);
  const [componentToDelete, setComponentToDelete] = useState(null);
  const [incidentToDelete, setIncidentToDelete] = useState(null);
  const [componentName, setComponentName] = useState('');
  const [profilePicModal, setProfilePicModal] = useState(false);
  const [data, setData] = useState(null);
  const [componentType, setComponentType] = useState('internal');
  const [selectedAwsService, setSelectedAwsService] = useState(null);

  const { incident } = useSelector(state => ({
    incident: state.Incidents.incident
  }));
  const [hoveredTimelineData, setHoveredTimelineData] = useState({
    isHovering: false,
    componentId: null,
    blockIndex: null,
    date: null,
    incidents: [],
    alerts: [],
    uptimePercentage: null,
    awsEvents: [],
    isAwsService: false
  });
  const { services, incidents, components, pingMonitors,timestamps,mapped_alerts,
    time_stamp_data,time_stamp_data_for_one_day, external_components, aws_health_events } = useSelector(state => ({
    services: state.Service.services,
    incidents: state.Incidents.incidents || [],
    components: state.Incidents.components || [],
    pingMonitors: state.PingMonitor.pingMonitors || [],
    timestamps: state.PingMonitor.timestamps,
    time_stamp_data: state.Incidents.time_stamp_data,
    external_components: state.Incidents.external_components || [],
    time_stamp_data_for_one_day: state.Incidents.time_stamp_data_for_one_day,
    aws_health_events: state.Incidents.aws_health_events || [],
    mapped_alerts: state.Incidents.mapped_alerts,
  }));

  const endpointsByService = React.useMemo(() => {
    return pingMonitors.reduce((acc, monitor) => {
      const serviceId = monitor.application_service_id;
      if (!acc[serviceId]) {
        acc[serviceId] = [];
      }
      acc[serviceId].push({
        value: monitor.id,
        label: monitor.name,
        endpoint: monitor.endpoint
      });
      return acc;
    }, {});
  }, [pingMonitors]);

  const serviceOptions = services.map(service => ({
    value: service.id,
    label: service.name
  }));
  const handleServiceChange = (selected) => {
    setSelectedService(selected);
    setSelectedEndpoint(null);
    if (selected) {
      setEndpointOptions(endpointsByService[selected.value] || []);
    } else {
      setEndpointOptions([]);
    }
  };

  const handleComponentSubmit = async () => {
    let payload = {};
    if (componentType === 'internal') {
      if (!componentName.trim() || !selectedService) return;
      payload = {
        type: 'internal',
        name: componentName.trim(),
        application_service_id: selectedService.value
      };
      if (selectedEndpoint) {
        payload.endpoint_id = selectedEndpoint.value;
      }
    } else {
      if (!selectedAwsService) return;
      const selectedService = external_components.find(service => service.id === selectedAwsService.value);
      payload = {
        type: 'external',
        name: `${selectedService.service_name} (${selectedService.region_name})`,
        external_service_component_id: selectedAwsService.value
      };
    }
    try {
      const response = await dispatch(createComponentService(payload));
      if (response) {
        setShowComponentForm(false);
        setComponentType('internal');
        setSelectedService(null);
        setSelectedEndpoint(null);
        setSelectedAwsService(null);
        setComponentName('');
      }
    } catch (error) {
      console.error("Error creating component:", error);
    }
  };

  useEffect(() => {
    dispatch(ongetIncidents());
    dispatch(onGetPingMonitors());
    dispatch(onGetServices());
    dispatch(getComponents());
    dispatch(getExternalComponents());
    dispatch(getAWSHealthEvents());
    dispatch(getMappedAlerts());
    dispatch(getTimeStampData({'duration_in_minutes': selectedRange * 24 * 60}));
  }, [ongetIncidents,onGetPingMonitors,onGetServices,getComponents,getExternalComponents,getAWSHealthEvents]);

  useEffect(() => {
      dispatch(getTimeStampDataForOneDay({'duration_in_minutes': 24 * 60}))
    }, [dispatch,selectedRange]);

  const toggleExpand = (id) => {
    setExpandedCards(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  const currentIncidents = incidents.filter(inc =>
    (!inc.ended_at || new Date(inc.ended_at) > new Date()) && inc.status !== 'Resolved'
  );
  const pastIncidents = incidents.filter(inc =>
    (inc.ended_at && new Date(inc.ended_at) <= new Date()) || inc.status === 'Resolved'
  );

  const formatDate = (dateString) => {
    return format(new Date(dateString), 'MMMM d, yyyy - h:mm:ss a');
  };
  const getStatusBadgeColor = (status) => {
      switch (status) {
        case "Investigating":
          return "badge-soft-warning";
        case "Identified":
          return "badge-soft-info";
        case "Resolved":
          return "badge-soft-success";
        case "Monitoring":
          return "badge-soft-primary";
        default:
          return "badge-soft-light";
      }
    };

  const getSeverityBadgeColor = (severity) => {
    switch (severity?.toLowerCase()) {
      case "critical":
      case "high":
        return "badge-soft-danger";
      case "medium":
        return "badge-soft-warning";
      case "low":
        return "badge-soft-info";
      default:
        return "badge-soft-light";
    }
  };

  const getSeverityColor = (severity) => {
    if (!severity) return '#198754';
    switch (severity.toLowerCase()) {
        case 'critical':
          return '#dc3545';
        case 'high':
          return '#dc3545';
        case 'medium':
          return '#ffc107';
        case 'low':
          return '#0d6efd';
        default:
          return '#198754';
      }
    };

  const customStyles = {
    container: (provided) => ({
      ...provided,
      backgroundColor: 'transparent',
    }),
    control: (provided) => ({
      ...provided,
      backgroundColor: 'transparent',
      borderColor: '#485EC4',
      color: '#fff',
      minHeight: '38px',
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#fff',
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: '#485EC4',
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: '#fff',
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: '#fff',
      ':hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.15)',
        color: '#fff',
      },
    }),
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? '#fff' : '#fff',
      backgroundColor: state.isSelected ? '#485EC4' : 'transparent',
      '&:hover': {
        backgroundColor: '#485EC4',
      },
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: '#222736',
      maxHeight: '200px',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px',
    }),
    input: (provided) => ({
      ...provided,
      color: '#fff',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#aaa',
    }),
  };

  const rangeOptions = [
    { value: 30, label: '30 Days' },
    { value: 60, label: '60 Days' },
    { value: 90, label: '90 Days' },
  ];
  const fetchAllTimestamps = async () => {
    dispatch(getTimeStampData({'duration_in_minutes': selectedRange * 24 * 60}))
  };

  const isValidTimestampData = (timestamps) => {
    if (!timestamps || typeof timestamps !== 'object') return false;
    const timestampEntries = Object.entries(timestamps).filter(
      ([key]) => key !== 'organization_id' && key !== 'application_id'
    );
    return timestampEntries.length > 0;
  };


  // useEffect(() => {
  //   if (fetchingEndpointId && timestamps) {
  //     if (isValidTimestampData(timestamps)) {
  //       setEndpointTimestamps(prev => ({
  //         ...prev,
  //         [fetchingEndpointId]: timestamps
  //       }));
  //     } else {
  //       setEndpointTimestamps(prev => {
  //         const newState = { ...prev };
  //         delete newState[fetchingEndpointId];
  //         return newState;
  //       });
  //     }
  //     setIsLoading(prev => ({ ...prev, [fetchingEndpointId]: false }));
  //   }
  // }, [timestamps, fetchingEndpointId]);

  useEffect(() => {
    setIsLoading({});
    if (components.length > 0) {
      fetchAllTimestamps();
    }
  }, [selectedRange]);

  const calculateDowntimeFromIncidents = (componentId, startDate, endDate) => {
    const startMoment = moment(startDate).tz(Intl.DateTimeFormat().resolvedOptions().timeZone);
    const endMoment = moment(endDate).tz(Intl.DateTimeFormat().resolvedOptions().timeZone);
    const currentTime = moment().tz(Intl.DateTimeFormat().resolvedOptions().timeZone);
    const relevantIncidents = incidents.filter(incident => {
      const isAffected = incident.affected_services.some(
          service => service.component_service_id === componentId
      );
      if (!isAffected) return false;
      const incidentStartDate = moment(incident.started_at)
          .tz(Intl.DateTimeFormat().resolvedOptions().timeZone);
      const isOngoing = incident.ended_at === null || incident.status !== "Resolved";
      const incidentEndDate = isOngoing
          ? currentTime
          : moment(incident.ended_at).tz(Intl.DateTimeFormat().resolvedOptions().timeZone);

      return (
          incidentStartDate.isSameOrBefore(endMoment) &&
          incidentEndDate.isSameOrAfter(startMoment)
      );
    });
    const relevantAlerts = mapped_alerts.filter(mappedAlert =>
        mappedAlert.component_service_id === componentId &&
        mappedAlert.alert_logs &&
        mappedAlert.alert_logs.length > 0
    ).flatMap(mappedAlert =>
        mappedAlert.alert_logs.map(log => ({
          ...log,
          severity: mappedAlert.severity
        }))
    ).filter(log =>
        log.status === "Alarm" || log.status === "Ok"
    );
    let downtimeSegments = relevantIncidents.map(incident => {
      const incidentStart = moment(incident.started_at)
          .tz(Intl.DateTimeFormat().resolvedOptions().timeZone);
      const isOngoing = incident.ended_at === null || incident.status !== "Resolved";
      const incidentEnd = isOngoing
          ? currentTime
          : moment(incident.ended_at).tz(Intl.DateTimeFormat().resolvedOptions().timeZone);
      const effectiveStart = moment.max(incidentStart, startMoment);
      const effectiveEnd = moment.min(incidentEnd, endMoment);
      return {
        start: effectiveStart,
        end: effectiveEnd,
        source: 'incident',
        id: incident.id
      };
    }).filter(segment => segment.end.isAfter(segment.start));
    const alertSegments = relevantAlerts.map(log => {
      const alertStart = moment(log.opened_at)
          .tz(Intl.DateTimeFormat().resolvedOptions().timeZone);
      const isOngoing = log.closed_at === null && log.status === "Alarm";
      const alertEnd = isOngoing
          ? currentTime
          : moment(log.closed_at).tz(Intl.DateTimeFormat().resolvedOptions().timeZone);

      const effectiveStart = moment.max(alertStart, startMoment);
      const effectiveEnd = moment.min(alertEnd, endMoment);
      return {
        start: effectiveStart,
        end: effectiveEnd,
        source: 'alert',
        id: log.id
      };
    }).filter(segment => segment.end.isAfter(segment.start));
    downtimeSegments = [...downtimeSegments, ...alertSegments];
    downtimeSegments.sort((a, b) => a.start.valueOf() - b.start.valueOf());
    let mergedSegments = [];
    if (downtimeSegments.length > 0) {
      let currentSegment = { ...downtimeSegments[0] };
      for (let i = 1; i < downtimeSegments.length; i++) {
        const segment = downtimeSegments[i];
        if (segment.start.isSameOrBefore(currentSegment.end)) {
          if (currentSegment.source === 'alert' && segment.source === 'incident') {
            currentSegment.source = 'incident';
            currentSegment.id = segment.id;
          }
          currentSegment.end = moment.max(currentSegment.end, segment.end);
        } else {
          mergedSegments.push(currentSegment);
          currentSegment = { ...segment };
        }
      }
      mergedSegments.push(currentSegment);
    }
    let totalDowntimeMinutes = 0;
    mergedSegments.forEach(segment => {
      const durationMinutes = segment.end.diff(segment.start, 'minutes');
      totalDowntimeMinutes += Math.max(0, durationMinutes);
    });
    const now = moment().tz(Intl.DateTimeFormat().resolvedOptions().timeZone);
    const isCurrentDay = startMoment.isSame(now, 'day');
    let totalMinutesInRange;
    if (isCurrentDay) {
      totalMinutesInRange = now.diff(now.clone().startOf('day'), 'minutes');
    } else {
      totalMinutesInRange = endMoment.diff(startMoment, 'minutes');
    }
    if (totalMinutesInRange <= 0) {
      totalMinutesInRange = 1;
    }
    const downtimePercentage = (totalDowntimeMinutes / totalMinutesInRange) * 100;
    return downtimePercentage;
  };

  const calculateUptimeForTimeRange = (timestamps, startDate, endDate) => {
    if (!isValidTimestampData(timestamps)) {
      return 'No data';
    }
    let totalUptime = 0;
    let count = 0;
    Object.entries(timestamps).forEach(([timestampStr, data]) => {
      if (timestampStr === 'organization_id' || timestampStr === 'application_id') {
        return;
      }
      const timestamp = new Date(timestampStr);
      if (timestamp >= startDate && timestamp <= endDate) {
        totalUptime += data.is_up;
        count++;
      }
    });
    if (count > 0) {
      const value = totalUptime / count * 100;
      const [whole, decimal] = String(value).split('.');
      const truncated = `${whole}.${decimal ? decimal.slice(0, 2) : '00'}`;
      return truncated;
    }
    return 'No data';
  };

  const calculateAlertDowntimeOnly = (componentId, startDate, endDate) => {
    const startMoment = moment(startDate);
    const endMoment = moment(endDate);
    const now = moment();
    const relevantAlerts = mapped_alerts
        .filter(mappedAlert => mappedAlert.component_service_id === componentId)
        .flatMap(mappedAlert =>
            mappedAlert.alert_logs
                .filter(log => log.status === "Alarm" || log.status === "Ok")
                .map(log => ({
                  ...log,
                  severity: mappedAlert.severity
                }))
        )
        .filter(log => {
          const alertStart = moment(log.opened_at);
          const alertEnd = log.closed_at ? moment(log.closed_at) : now;
          return alertStart.isSameOrBefore(endMoment) && alertEnd.isSameOrAfter(startMoment);
        });
    const alertSegments = relevantAlerts.map(log => {
      const alertStart = moment(log.opened_at);
      const isOngoing = log.closed_at === null && log.status === "Alarm";
      const alertEnd = isOngoing ? now : moment(log.closed_at);
      const effectiveStart = moment.max(alertStart, startMoment);
      const effectiveEnd = moment.min(alertEnd, endMoment);
      return {
        start: effectiveStart,
        end: effectiveEnd,
        source: 'alert',
        id: log.id
      };
    }).filter(segment => segment.end.isAfter(segment.start));
    alertSegments.sort((a, b) => a.start.valueOf() - b.start.valueOf());
    let mergedSegments = [];
    if (alertSegments.length > 0) {
      let currentSegment = { ...alertSegments[0] };
      for (let i = 1; i < alertSegments.length; i++) {
        const segment = alertSegments[i];
        if (segment.start.isSameOrBefore(currentSegment.end)) {
          currentSegment.end = moment.max(currentSegment.end, segment.end);
        } else {
          mergedSegments.push(currentSegment);
          currentSegment = { ...segment };
        }
      }
      mergedSegments.push(currentSegment);
    }
    let totalDowntimeMinutes = mergedSegments.reduce((total, segment) => {
      return total + segment.end.diff(segment.start, 'minutes');
    }, 0);
    const isCurrentDay = startMoment.isSame(now, 'day');
    const totalMinutesInRange = isCurrentDay
        ? now.diff(now.clone().startOf('day'), 'minutes')
        : endMoment.diff(startMoment, 'minutes');
    const downtimePercentage = (totalDowntimeMinutes / Math.max(1, totalMinutesInRange)) * 100;
    return downtimePercentage;
  };

  const calculateUptimeForRange = (component) => {
    if (component.endpoint_id) {
    const current_end_point_timestamp = time_stamp_data
          .find(obj => Object.keys(obj)[0] === component.endpoint_id)?.[component.endpoint_id] || [];
      if (!current_end_point_timestamp || isLoading[component.endpoint_id]) {
        const endDate = new Date();
        const startDate = new Date();
        startDate.setDate(startDate.getDate() - selectedRange);
        const alertDowntime = calculateAlertDowntimeOnly(component.id, startDate, endDate);
        if (alertDowntime > 0) {
          const uptimePercentage = 100 - alertDowntime;
          const [whole, decimal] = String(uptimePercentage).split('.');
          return `${whole}.${decimal ? decimal.slice(0, 2) : '00'}`;
        }
        return "No data";
      }
      const endDate = new Date();
      const startDate = new Date();
      startDate.setDate(startDate.getDate() - selectedRange);
      const pingUptime = calculateUptimeForTimeRange(current_end_point_timestamp, startDate, endDate);
      const alertDowntime = calculateAlertDowntimeOnly(component.id, startDate, endDate);
      if (alertDowntime > 0) {
        const combinedUptime = Math.max(0, parseFloat(pingUptime) - alertDowntime);
        const [whole, decimal] = String(combinedUptime).split('.');
        return `${whole}.${decimal ? decimal.slice(0, 2) : '00'}`;
      }
      return pingUptime;
    } else {
      const endDate = new Date();
      const startDate = new Date();
      startDate.setDate(startDate.getDate() - selectedRange);
      const downtimePercentage = calculateDowntimeFromIncidents(component.id, startDate, endDate);
      const uptimePercentage = 100 - downtimePercentage;
      const [whole, decimal] = String(uptimePercentage).split('.');
      return `${whole}.${decimal ? decimal.slice(0, 2) : '00'}`;
    }
  };

  const getUptimeDataForComponentByDate = (componentId) => {
    const today = new Date();
    const component = components.find(c => c.id === componentId);
    if (!component) return [];
    return Array.from({ length: selectedRange }, (_, i) => {
      const date = moment(today).subtract(selectedRange - 1 - i, 'days').toDate();
      const isToday = moment(date).isSame(moment(), 'day');
      const dayStart = moment(date).startOf('day');
      const dayEnd = isToday ? moment() : moment(date).endOf('day');
      if (component.external_service_component_id) {
        const awsEvents = aws_health_events.filter(event => {
          const isForThisComponent = event.external_service_component_id === component.external_service_component_id;
          if (!isForThisComponent) return false;

          const eventStart = moment(event.startTime);
          const eventEnd = event.endTime ? moment(event.endTime) : moment();
          return eventStart.isSameOrBefore(dayEnd) && eventEnd.isSameOrAfter(dayStart);
        });
        return {
          date,
          awsEvents,
          uptimePercentage: awsEvents.length > 0 ? 'AWS Event' : 'OK',
          isToday: isToday,
          isAwsService: true,
          hasAwsEvent: awsEvents.length > 0
        };
      }
      let uptimePercentage;
      if (component.endpoint_id) {
        const currentTimestamps = time_stamp_data.find(obj => Object.keys(obj)[0] === component.endpoint_id)?.[component.endpoint_id] || [];
        const todayTimestamps = time_stamp_data_for_one_day?.find(obj => Object.keys(obj)[0] === component.endpoint_id)?.[component.endpoint_id];
        if (!currentTimestamps || isLoading[component.endpoint_id]) {
          const alertDowntime = calculateAlertDowntimeOnly(
              component.id,
              dayStart.toDate(),
              dayEnd.toDate()
          );
          if (alertDowntime > 0) {
            const dayUptimePercentage = 100 - alertDowntime;
            const [whole, decimal] = String(dayUptimePercentage).split('.');
            uptimePercentage = `${whole}.${decimal ? decimal.slice(0, 2) : '00'}`;
          } else {
            uptimePercentage = 'No data';
          }
        } else {
          const timestampsToUse = isToday && todayTimestamps ? todayTimestamps : currentTimestamps;
          const pingUptime = calculateUptimeForTimeRange(
              timestampsToUse,
              dayStart.toDate(),
              dayEnd.toDate()
          );
          const alertDowntime = calculateAlertDowntimeOnly(
              component.id,
              dayStart.toDate(),
              dayEnd.toDate()
          );
          if (pingUptime === 'No data') {
            uptimePercentage = alertDowntime > 0 ?
                (100 - alertDowntime).toFixed(2) :
                'No data';
          } else if (parseFloat(pingUptime) >= 100 && alertDowntime > 0) {
            uptimePercentage = (100 - alertDowntime).toFixed(2);
          } else {
            uptimePercentage = pingUptime;
          }
        }
      } else {
        const downtimePercentage = calculateDowntimeFromIncidents(
            componentId,
            dayStart.toDate(),
            dayEnd.toDate()
        );

        const downtimeAsNumber = parseFloat(downtimePercentage) || 0;
        const dayUptimePercentage = 100 - downtimeAsNumber;
        const [whole, decimal] = String(dayUptimePercentage).split('.');
        uptimePercentage = `${whole}.${decimal ? decimal.slice(0, 2) : '00'}`;
      }
      const dayIncidents = incidents.filter(incident => {
        const isAffected = incident.affected_services.some(
            service => service.component_service_id === componentId
        );
        if (!isAffected) return false;
        const incidentStartDate = moment(incident.started_at)
            .tz(Intl.DateTimeFormat().resolvedOptions().timeZone);
        const isOngoing = incident.ended_at === null || incident.status !== "Resolved";
        const incidentEndDate = isOngoing
            ? moment().tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
            : moment(incident.ended_at).tz(Intl.DateTimeFormat().resolvedOptions().timeZone);

        return (
            incidentStartDate.isSameOrBefore(dayEnd) &&
            incidentEndDate.isSameOrAfter(dayStart)
        );
      });
      const dayAlerts = [];
      mapped_alerts.forEach(mappedAlert => {
        if (mappedAlert.component_service_id === componentId && mappedAlert.alert_logs) {
          mappedAlert.alert_logs.forEach(log => {
            const alertStartDate = moment(log.opened_at)
                .tz(Intl.DateTimeFormat().resolvedOptions().timeZone);
            const isOngoing = log.closed_at === null && log.status === "Alarm";
            const alertEndDate = isOngoing
                ? moment().tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
                : moment(log.closed_at).tz(Intl.DateTimeFormat().resolvedOptions().timeZone);

            const overlapsDay = (
                alertStartDate.isSameOrBefore(dayEnd) &&
                alertEndDate.isSameOrAfter(dayStart)
            );

            if (overlapsDay && (log.status === "Alarm" || log.status === "Ok")) {
              dayAlerts.push({
                ...log,
                mappedAlertId: mappedAlert.id,
                severity: mappedAlert.severity,
                name: log.name || `Alert ${log.id}`
              });
            }
          });
        }
      });
      return {
        date,
        incidents: dayIncidents,
        alerts: dayAlerts,
        uptimePercentage,
        isToday: isToday,
        isAwsService: false
      };
    });
  };

  const isAwsServiceDown = (externalServiceComponentId) => {
    const now = moment();
    return aws_health_events.some(event =>
        event.external_service_component_id === externalServiceComponentId &&
        moment(event.startTime).isBefore(now) &&
        (!event.endTime || moment(event.endTime).isAfter(now))
    );
  };
  const hasActiveAwsEvent = (externalServiceComponentId) => {
    const now = moment();
    return aws_health_events.some(event =>
        event.external_service_component_id === externalServiceComponentId &&
        moment(event.startTime).isBefore(now) &&
        (!event.endTime || moment(event.endTime).isAfter(now))
    );
  };

  //
  // const fetchTimestampsForComponent = async (endpointId, days) => {
  //   try {
  //     setEndpointTimestamps(prev => {
  //       const newState = { ...prev };
  //       delete newState[endpointId];
  //       return newState;
  //     });
  //     setIsLoading(prev => ({ ...prev, [endpointId]: true }));
  //     setFetchingEndpointId(endpointId);
  //     const timeframeInMinutes = days * 24 * 60;
  //     dispatch(onGetTimestamps({
  //       'endpoint_id': endpointId,
  //       'duration_in_minutes': timeframeInMinutes
  //     }));
  //   } catch (error) {
  //     console.error(`Error fetching timestamps for endpoint ${endpointId}:`, error);
  //     setIsLoading(prev => ({ ...prev, [endpointId]: false }));
  //   }
  // };
  //
  const getBlockColor = (dayData) => {
    if (dayData.isAwsService) {
      return dayData.hasAwsEvent ? '#F59E0B' : '#10B981';
    }
    let uptimePercentage = dayData.uptimePercentage === 'No data' ? null : parseFloat(dayData.uptimePercentage);
    if(dayData.incidents.length > 0)
      return getSeverityColor(getHighestSeverity(dayData.incidents));
    if(dayData.alerts.length > 0)
      return getSeverityColor(getHighestSeverity(dayData.alerts));
    if (uptimePercentage === null || uptimePercentage === 'No data')
      return '#10B981';
    const percentage = typeof uptimePercentage === 'string' ? parseFloat(uptimePercentage) : uptimePercentage;
    if (isNaN(percentage))
      return '#10B981';
    if (percentage === 100)
      return '#10B981';
    if (percentage >= 99.9 && percentage < 100)
      return '#F59E0B';
    return '#EF4444';
  };
  const getLastPingStatus = (endpointId) => {
    const component = components.find(c => c.endpoint_id === endpointId);
    if (!component) return false;
    const componentData = getUptimeDataForComponentByDate(component.id);
    const todayData = componentData[componentData.length - 1];

    const overallUptime = calculateUptimeForRange(endpointId);
    const isTodayNoData = todayData?.uptimePercentage === 'No data';
    const isOverallNoData = overallUptime === 'No data';

    if (isTodayNoData && isOverallNoData) {
      return true;
    }
    const hasOngoingIncident = incidents.some(incident =>
      incident.status !== 'Resolved' &&
      incident.affected_services.some(
        service => service.component_service_id === component.id
      )
    );
    if (hasOngoingIncident) {
      return false;
    }
    const monitor = pingMonitors.find(m => m.id === endpointId);
    return monitor?.last_ping_successful || false;
  };

  const getBlockWidth = () => {
    switch (selectedRange) {
      case 1: return 96;
      case 90:
        return 1.11;
      case 60:
        return 1.66;
      default:
        return 3.33;
    }
  };

  const rangeSelectStyles = {
    ...customStyles,
    container: (provided) => ({
      ...provided,
      width: '150px',
      marginLeft: '15px',
    }),
  };

  const getWeeksForMonth = (month) => {
    if (!isValid(month)) return [];
    const start = startOfWeek(startOfMonth(month));
    const end = endOfWeek(endOfMonth(month));
    const days = [];
    let currentDay = start;
    while (currentDay <= end) {
      days.push(currentDay);
      currentDay = addDays(currentDay, 1);
    }
    const weeks = [];
    for (let i = 0; i < days.length; i += 7) {
      weeks.push(days.slice(i, i + 7));
    }
    return weeks;
  };

  const incidentsByDate = React.useMemo(() => {
    const acc = incidents.reduce((acc, incident) => {
      const startDate = new Date(incident.started_at);
      const endDate = incident.ended_at ? new Date(incident.ended_at) : new Date();
      if (!isValid(startDate) || !isValid(endDate)) {
        return acc;
      }
      try {
        const incidentDays = eachDayOfInterval({
          start: startOfDay(startDate),
          end: endOfDay(endDate)
        });
        incidentDays.forEach(date => {
          const dateStr = format(date, 'yyyy-MM-dd');
          if (!acc[dateStr]) {
            acc[dateStr] = {
              incidents: [],
              alerts: [],
              affectedServices: new Set()
            };
          }
          if (!incident.ended_at || new Date(dateStr) <= new Date(incident.ended_at)) {
            acc[dateStr].incidents.push(incident);
            incident.affected_services.forEach(service => {
              const serviceName = service.component_name
                ? `${service.component_name}`
                : service.application_service_name;
              acc[dateStr].affectedServices.add(serviceName);
            });
          }
        });
      } catch (error) {
        console.error("Error processing incident dates:", error);
      }
      return acc;
    }, {});
    mapped_alerts.forEach(mappedAlert => {
      if (!mappedAlert.alert_logs || mappedAlert.alert_logs.length === 0) {
        return;
      }
      mappedAlert.alert_logs.forEach(log => {
        if (log.status !== "Alarm" && log.status !== "Ok") {
          return;
        }
        const startDate = new Date(log.opened_at);
        const endDate = log.closed_at ? new Date(log.closed_at) : new Date();
        if (!isValid(startDate) || !isValid(endDate)) {
          return;
        }
        try {
          const alertDays = eachDayOfInterval({
            start: startOfDay(startDate),
            end: endOfDay(endDate)
          });
          alertDays.forEach(date => {
            const dateStr = format(date, 'yyyy-MM-dd');
            if (!acc[dateStr]) {
              acc[dateStr] = {
                incidents: [],
                alerts: [],
                affectedServices: new Set()
              };
            }
            const component = components.find(c => c.id === mappedAlert.component_service_id);
            if (component) {
              acc[dateStr].alerts.push({
                ...log,
                severity: mappedAlert.severity,
                component_name: component.name,
                application_service_name: component.application_service_name
              });
              const serviceName = component.name || component.application_service_name;
              acc[dateStr].affectedServices.add(serviceName);
            }
          });
        } catch (error) {
          console.error("Error processing alert dates:", error, "for log:", log.id);
        }
      });
    });
    return acc;
  }, [incidents, mapped_alerts, components]);

  const getHighestSeverity = (items) => {
    if (!items || items.length === 0) return null;
    const severityOrder = {
      'critical': 4,
      'high': 3,
      'medium': 2,
      'low': 1,
    };
    return items.reduce((highest, item) => {
      const itemSeverity = item.severity ? item.severity.toLowerCase() : '';
      const currentSeverityRank = severityOrder[itemSeverity] || 0;
      const highestSeverityRank = severityOrder[highest?.toLowerCase()] || 0;
      return currentSeverityRank > highestSeverityRank ? item.severity : highest;
    }, null);
  };

  const calendarData = React.useMemo(() => {
    const today = new Date();
    const threeMonthsAgo = startOfMonth(subMonths(today, 2));
    const monthsToShow = [
      threeMonthsAgo,
      addDays(startOfMonth(subMonths(today, 1)), 0),
      addDays(startOfMonth(today), 0)
    ];
    return monthsToShow.map(monthDate => ({
      month: format(monthDate, 'MMMM'),
      monthDate: monthDate,
      weeks: getWeeksForMonth(monthDate)
    }));
  }, []);

  const [formData, setFormData] = useState({
    name: '',
    status: null,
    severity: null,
    description: '',
    message: '',
    sendNotifications: false
  });

  const incidentStatuses = [
    { value: 'Investigating', label: 'Investigating' },
    { value: 'Identified', label: 'Identified' },
    { value: 'Resolved', label: 'Resolved' },
    { value: 'Monitoring', label: 'Monitoring' }
  ];

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };
  const [touched, setTouched] = useState({});
  const handleBlur = (field) => {
    setTouched(prev => ({
      ...prev,
      [field]: true
    }));
  };
  const updateIncidents= (id) => {
    setTouched({
      status: true,
      message: true
    });

    if (!formData.status || !formData.message) {
      return;
    }
    const updatePayload = {
      id: id,
      status: formData.status.value,
      message: formData.message,
    };
    dispatch(updateIncident(updatePayload));
    // navigate('/status-page-management');
  }

  const handleDeleteComponent =  (componentId) => {
    setComponentToDelete(componentId);
    setShowDeleteComponentModal(true);
  }

  function cancelDeleteComponent() {
    setShowDeleteComponentModal(false);
    setComponentToDelete(null);
  }

  function deleteComponent() {
    let payload = {
      component_id: componentToDelete
    }
    dispatch(deleteComponentService(payload));
    setShowDeleteComponentModal(false);
    setComponentToDelete(null);
  }

  const handleDeleteIncident = (incidentId) => {
    setIncidentToDelete(incidentId);
    setShowDeleteIncidentModal(true);
  }

  function cancelDeleteIncident() {
    setShowDeleteIncidentModal(false);
    setIncidentToDelete(null);
  }
  function deleteTheIncident() {
    let payload = {
      incident_id: incidentToDelete
    }
    dispatch(deleteIncident(payload));
    setShowDeleteIncidentModal(false);
    setIncidentToDelete(null)
  }

  useEffect(() => {
    dispatch(onGetOrganization())
  }, [dispatch]);

  const { organizationDetail} = useSelector(state => ({
    organizationDetail: state.Organization.organization || [],
  }))

  function onUpdateProfilePic() {
    if (profilePicModal) {
      setProfilePicModal(false);
    } else {
      setProfilePicModal(true);
    }
  }
  const profilePicToggle = () => {
    if (profilePicModal) {
      setProfilePicModal(false);
    } else {
      setProfilePicModal(true);
    }
  }

  return (
    <div>
      <SideBar current_page={"Incident Management"}/>
      <div className="container-fluid p-4" style={{width: '60%'}}>
        <div className="mb-4" style={{marginBottom: "10px"}}>
          <OnUpdateProfilePicModal
            isOpen={profilePicModal}
            toggle={profilePicToggle}
            userEmail={data?.email}
            page="Organization"
          />
          <div className="d-flex justify-content-center">
            <div
              id="editProfilePictooltip"
              onClick={() => onUpdateProfilePic()}
              className="d-flex justify-content-center position-relative"
              style={{
                width: "15%",
                height: "15%",
                cursor: "pointer",
              }}
            >
              {organizationDetail?.logo ? (
                <img
                  src={organizationDetail.logo}
                  alt="Profile"
                  style={{
                    width: "300px",
                    height: "150px",
                    objectFit: "contain"
                  }}
                />
              ) : (
                <div className='d-flex w-100 justify-content-center mt-2'
                     style={{marginLeft: '5%'}}>
                  <div className='fas fa-image'
                       style={{
                         fontSize: '125px'
                       }}>
                  </div>
                </div>
              )}
              <div className="d-flex justify-content-end pt-4">
                <Link
                  className="text-success p-1"
                  onClick={() => onUpdateProfilePic()}
                >
                  <div className="bg-white px-1 rounded-circle">
                    <i className="mdi mdi-pencil font-size-12"/>
                  </div>
                  <UncontrolledTooltip
                    className="status-page-tooltip-component"
                    placement="right-start"
                    target="editProfilePictooltip"
                  >
                    Update Organization Logo
                  </UncontrolledTooltip>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h4 className="text-white">Status Page Management</h4>
          <div className="d-flex align-items-center">
            <Link
                className="btn btn-primary me-3"
                to={`/associate-alerts-with-statuspage`}
            >
              Associate Alerts
            </Link>
            <span
                className="text-primary d-flex align-items-center"
                style={{ cursor: 'pointer' }}
                onClick={() => window.open('/status-page', '_blank', 'noopener,noreferrer')}
            >
              Go to Status Page
              <i
                  className="bx bx-link-external ms-1"
                  style={{
                    fontSize: '16px',
                    flexShrink: 0
                  }}
              />
            </span>
          </div>
        </div>
        <div className="card bg-transparent mb-4">
          <div className="card-body">
            <div className="d-flex flex-wrap justify-content-center">
              {calendarData.map(({ month, monthDate, weeks }) => (
                <div key={month} className="flex-grow-1" style={{ minWidth: '200px', maxWidth: '350px', justifyItems: 'center' }}>
                  <h6 className="text-white mb-3">{month}</h6>
                  {weeks.map((week, weekIndex) => (
                    <div key={weekIndex} className="d-flex gap-2 mb-2">
                      {week.map((date, dayIndex) => {
                        const dateStr = format(date, 'yyyy-MM-dd');
                        const dayData = incidentsByDate[dateStr] || { incidents: [], affectedServices: new Set(),alerts: [] };
                        const isCurrentMonth = isSameMonth(date, monthDate);
                        return (
                          <div
                            key={dayIndex}
                            className="position-relative"
                            onMouseEnter={() => isCurrentMonth ? setHoveredCalendarDay(date) : null}
                            onMouseLeave={() => setHoveredCalendarDay(null)}
                            style={{ cursor: isCurrentMonth ? 'pointer' : 'default' }}
                          >
                            <div
                              className="rounded-circle"
                              style={{
                                width: '16px',
                                height: '16px',
                                backgroundColor: getSeverityColor(getHighestSeverity([...dayData.incidents, ...dayData.alerts])),
                                opacity: !isCurrentMonth || isFuture(date) ? 0.3 : 1
                              }}
                            />
                            {hoveredCalendarDay && format(hoveredCalendarDay, 'yyyy-MM-dd') === format(date, 'yyyy-MM-dd') && isCurrentMonth && (
                              <div
                                className="position-absolute"
                                style={{
                                  backgroundColor: 'rgba(0, 0, 0, 0.8)',
                                  minWidth: '200px',
                                  transform: 'translateX(-50%)',
                                  left: '50%',
                                  top: '100%',
                                  zIndex: 1000,
                                  padding: '12px',
                                  borderRadius: '4px',
                                  marginTop: '8px',
                                  border: '1px solid rgba(255, 255, 255, 0.1)'
                                }}
                              >
                              <div className="text-white">
                                <div className="fw-medium mb-2">
                                  {format(date, 'MMMM d, yyyy')}
                                </div>
                                {(dayData.incidents.length > 0 || dayData.alerts.length > 0) ? (
                                  <>
                                {dayData.incidents.length > 0 && (
                                    <div className="small mb-2">
                                      Incidents: {dayData.incidents.length}
                                    </div>
                                )}
                                {dayData.alerts.length > 0 && (
                                    <div className="small mb-2">
                                      Alerts: {dayData.alerts.length}
                                    </div>
                                )}
                                    <div className="small mb-2">
                                      Severity: {getHighestSeverity([...dayData.incidents, ...dayData.alerts])?.charAt(0).toUpperCase() +
                                        getHighestSeverity([...dayData.incidents, ...dayData.alerts])?.slice(1).toLowerCase() || 'None'}
                                    </div>
                                    <div className="small">
                                      <div className="mb-1">Affected Services:</div>
                                      {Array.from(dayData.affectedServices).map((service, idx) => (
                                        <div key={idx} className="text-white-50">
                                          • {service}
                                        </div>
                                      ))}
                                    </div>
                                  </>
                                ) : (
                                  <div className="small">
                                    No incidents or alerts reported
                                  </div>
                                )}
                              </div>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="card bg-transparent mb-1">
          <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="text-white mb-0">Services</h5>
            {!showComponentForm && (
                <button
                    className="btn btn-primary"
                    onClick={() => setShowComponentForm(true)}
                >
                    Add Service
                </button>
            )}
        </div>
      {showComponentForm && (
          <div className="row align-items-end mb-3">
            <div className="col-md-12 mb-3">
              <div className="d-flex gap-3">
                <button
                    className={`btn ${componentType === 'internal' ? 'btn-primary' : 'btn-outline-secondary'}`}
                    onClick={() => setComponentType('internal')}
                >
                  Internal Services
                </button>
                <button
                    className={`btn ${componentType === 'external' ? 'btn-primary' : 'btn-outline-secondary'}`}
                    onClick={() => setComponentType('external')}
                >
                  AWS Services
                </button>
              </div>
            </div>
            {componentType === 'internal' ? (
                <>
                  <div className="col-md-3">
                    <label className="text-white mb-2">Display Name</label>
                    <input
                        type="text"
                        className="form-control"
                        value={componentName}
                        onChange={(e) => setComponentName(e.target.value)}
                        placeholder="Enter service name"
                    />
                  </div>
                  <div className="col-md-3">
                    <label className="text-white mb-2">Application Service</label>
                    <Select
                        value={selectedService}
                        onChange={handleServiceChange}
                        options={serviceOptions}
                        styles={customStyles}
                        placeholder="Select Service"
                    />
                  </div>
                  <div className="col-md-3">
                    <label className="text-white mb-2">Endpoint (Optional)</label>
                    <Select
                        value={selectedEndpoint}
                        onChange={setSelectedEndpoint}
                        options={endpointOptions}
                        styles={customStyles}
                        isDisabled={!selectedService}
                        placeholder="Select Endpoint"
                        isClearable={true}
                    />
                  </div>
                </>
            ) : (
                <div className="col-md-9">
                  <label className="text-white mb-2">AWS Service</label>
                  <Select
                      value={selectedAwsService}
                      onChange={setSelectedAwsService}
                      options={external_components.map(service => ({
                        value: service.id,
                        label: `${service.service_name} (${service.region_name})`
                      }))}
                      styles={customStyles}
                      placeholder="Search AWS service..."
                      isClearable={true}
                      isSearchable={true}
                  />
                </div>
            )}
                <div className="col-md-3">
                <div className="d-flex gap-2">
                  <button
                    className="btn btn-primary"
                    onClick={handleComponentSubmit}
                    disabled={
                        (componentType === 'internal' && (!componentName.trim() || !selectedService)) ||
                        (componentType === 'external' && !selectedAwsService)
                    }
                  >
                    Add
                  </button>
                  <button
                    className="btn btn-secondary"
                    onClick={() => {
                      setShowComponentForm(false);
                      setComponentType('internal');
                      setSelectedService(null);
                      setSelectedEndpoint(null);
                      setSelectedAwsService(null);
                      setComponentName('');
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}
          {components && components.length > 0 ? (
          <div className="mt-1">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <Select
                value={rangeOptions.find(opt => opt.value === selectedRange)}
                onChange={(option) => setSelectedRange(option.value)}
                options={rangeOptions}
                styles={customStyles}
                className="ms-2"
              />
            </div>
            {components.map((component) => (
              <div
                key={component.id}
                className="d-flex flex-row align-items-center"
              >
                <div
                  style={{ width: '95%' }}
                  className='d-flex flex-column border rounded p-3 mb-3'>
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <div className="d-flex align-items-center gap-2">
                      {component.external_service_component_id ? (
                          isAwsServiceDown(component.external_service_component_id) ? (
                              <div className="d-flex align-items-center gap-2 text-white">
                                <i className="bx bx-x-circle" style={{ color: '#FFC107', fontSize: '18px' }}></i>
                              </div>
                          ) : (
                              <div className="d-flex align-items-center gap-2 text-white">
                                <i className="bx bx-check-circle" style={{ color: '#10B981', fontSize: '18px' }}></i>
                              </div>
                          )
                      ) : (
                          component.endpoint_id ? (
                              (() => {
                                const hasActiveAlert = mapped_alerts.some(alert =>
                                    alert.component_service_id === component.id &&
                                    alert.alert_logs?.some(log =>
                                        log.status === "Alarm" && !log.closed_at
                                    )
                                );
                            const uptime = calculateUptimeForRange(component);
                            const isPingSuccessful = getLastPingStatus(component.endpoint_id);
                                if (uptime === 'No data') {
                                  return (
                                      <div className="d-flex align-items-center gap-2 text-white">
                                        <i className="bx bx-question-mark" style={{ color: '#6B7280', fontSize: '18px' }}></i>
                                      </div>
                                  );
                            } else if (hasActiveAlert || !isPingSuccessful) {
                                  return (
                                      <div className="d-flex align-items-center gap-2 text-white">
                                        <i className="bx bx-x-circle" style={{ color: '#EF4444', fontSize: '18px' }}></i>
                                      </div>
                                  );
                                } else {
                                  return (
                                    <div className="d-flex align-items-center gap-2 text-white">
                                      <i className="bx bx-check-circle" style={{ color: '#10B981', fontSize: '18px' }}></i>
                                    </div>
                                  );
                                }
                              })()
                          ) : (
                          (() => {
                            const hasActiveAlert = mapped_alerts.some(alert =>
                              alert.component_service_id === component.id &&
                              alert.alert_logs?.some(log =>
                                log.status === "Alarm" && !log.closed_at
                              )
                            );
                            const hasActiveIncident = incidents.some(incident =>
                              incident.affected_services.some(service =>
                                service.component_service_id === component.id
                              ) &&
                              (incident.ended_at === null || incident.status !== "Resolved")
                            );
                            if (hasActiveAlert || hasActiveIncident) {
                              return (
                                <div className="d-flex align-items-center gap-2 text-white">
                                  <i className="bx bx-x-circle" style={{ color: '#EF4444', fontSize: '18px' }}></i>
                                </div>
                              );
                            } else {
                              return (
                                <div className="d-flex align-items-center gap-2 text-white">
                                  <i className="bx bx-check-circle" style={{ color: '#10B981', fontSize: '18px' }}></i>
                                </div>
                              );
                            }
                          })()
                        )
                      )}
                      <span className="text-white fw-medium">{component.name || component.application_service_name}</span>
                    </div>
                    <span className="text-white" style={{ fontSize: '0.875rem' }}>
                      {component.external_service_component_id ? (
                          hasActiveAwsEvent(component.external_service_component_id) ? 'Issues detected' : 'Operational'
                      ) : (
                          calculateUptimeForRange(component) === 'No data'
                              ? 'No data'
                              : `${calculateUptimeForRange(component)}% uptime`
                      )}
                    </span>
                  </div>
                <div
                  className="d-flex flex-column"
                  style={{ marginRight: '2px' }}
                  onMouseEnter={() => setHoveredTimelineData(prev => ({
                    ...prev,
                    isHovering: true,
                    componentId: component.id
                  }))}
                  onMouseLeave={() => setHoveredTimelineData({
                    isHovering: false,
                    componentId: null,
                    date: null,
                    incidents: [],
                    alerts: [],
                    uptimePercentage: null,
                    awsEvents: [],
                    isAwsService: false
                  })}
                >
                  <div className="d-flex gap-1">
                  {getUptimeDataForComponentByDate(component.id).map((day, index) => (
                    <div
                      key={index}
                      onMouseEnter={() => setHoveredTimelineData(prev => ({
                        ...prev,
                        isHovering: true,
                        componentId: component.id,
                        blockIndex: index,
                        date: day.date,
                        incidents: day.incidents,
                        alerts: day.alerts,
                        uptimePercentage: day.uptimePercentage,
                        awsEvents: day.awsEvents || [],
                        isAwsService: day.isAwsService || false
                      }))}
                      style={{
                        height: '30px',
                        width: `${getBlockWidth()}%`,
                        backgroundColor: getBlockColor(day),
                        borderRadius: '2px',
                        cursor: 'pointer',
                        transition: 'opacity 0.2s',
                        opacity: hoveredTimelineData.isHovering &&
                                hoveredTimelineData.componentId === component.id ?
                                (hoveredTimelineData.blockIndex === index ? 0.8 : 1) : 1
                      }}
                    />
                  ))}
                  </div>
                  <div className="d-flex justify-content-between mt-1">
                    <span className="text-secondary" style={{ fontSize: '0.75rem' }}>
                      {selectedRange} {selectedRange === 1 ? 'day' : 'days'} ago
                    </span>
                    <span className="text-secondary" style={{ fontSize: '0.75rem' }}>
                      NOW
                    </span>
                  </div>
                  {hoveredTimelineData.isHovering &&
                      hoveredTimelineData.componentId === component.id &&
                      hoveredTimelineData.date && (
                          <div
                              className="mt-2 p-3 border rounded"
                              style={{
                                backgroundColor: 'rgba(0, 0, 0, 0.2)',
                                transition: 'all 0.3s ease'
                              }}
                          >
                            <div className="d-flex flex-column gap-2 text-white">
                              <strong>
                                {format(new Date(hoveredTimelineData.date), 'MMMM d, yyyy')}
                              </strong>
                              {component.external_service_component_id ? (
                                  hoveredTimelineData.awsEvents && hoveredTimelineData.awsEvents.length > 0 ? (
                                      <div className="mt-2">
                                        <div className="text-secondary mb-1">AWS Health Events:</div>
                                        {hoveredTimelineData.awsEvents.map((event, idx) => (
                                            <div key={idx} className="text-white mt-1">
                                              <div className="d-flex align-items-start gap-2">
                                                <i className="bx bx-x-circle" style={{ color: '#F59E0B', fontSize: '18px', marginTop: '2px' }}></i>
                                                <div>
                                                  <div>{event.eventTypeCode.replace(/_/g, ' ')}</div>
                                                  <div className="text-secondary" style={{ fontSize: '0.85rem' }}>
                                                    {moment(event.startTime).format('HH:mm')} -
                                                    {event.endTime ? moment(event.endTime).format('HH:mm') : 'Ongoing'}
                                                  </div>
                                                  {event.eventDescription && event.eventDescription.length > 0 && (
                                                      <div className="mt-1" style={{ fontSize: '0.85rem' }}>
                                                        {event.eventDescription[0]?.latestDescription?.split('\n\n')[0] || 'No description available'}
                                                      </div>
                                                  )}
                                                </div>
                                              </div>
                                            </div>
                                        ))}
                                      </div>
                                  ) : (
                                      <div className="d-flex align-items-center gap-2 text-white mt-2">
                                        <i className="bx bx-check-circle" style={{ color: '#10B981', fontSize: '18px' }}></i>
                                        <span>No AWS service issues reported</span>
                                      </div>
                                  )
                              ) : (
                                  <>
                                    <div className="text-white">
                                      Uptime: {hoveredTimelineData.uptimePercentage}
                                      {hoveredTimelineData.uptimePercentage !== 'No data' && '%'}
                                    </div>
                                    {hoveredTimelineData.incidents && hoveredTimelineData.incidents.length > 0 ? (
                                        <div className="mt-2">
                                          <div className="text-secondary mb-1">Incidents:</div>
                                          {hoveredTimelineData.incidents.map((incident, idx) => (
                                              <div key={idx} className="text-white mt-1">
                                                {incident.name}
                                                <i
                                                    className={`badge rounded-pill ${getSeverityBadgeColor(incident.severity)}`}
                                                    style={{
                                                      fontStyle: 'normal',
                                                      fontSize: '11px',
                                                      padding: '4px 8px',
                                                      marginBottom: '4px',
                                                      marginLeft: '10px'
                                                    }}
                                                >
                                                  {incident.severity}
                                                </i>
                                                {incident.status === 'Resolved' && incident.ended_at ? (
                                                    <span className="text-white ms-2">
                                                      <i
                                                          className={`badge rounded-pill ${getStatusBadgeColor(incident.status)}`}
                                                          style={{
                                                            fontStyle: 'normal',
                                                            fontSize: '11px',
                                                            padding: '4px 8px',
                                                            marginBottom: '4px',
                                                            marginLeft: '5px',
                                                          }}
                                                      >
                                                        {incident.status} after {differenceInMinutes(
                                                          new Date(incident.ended_at),
                                                          new Date(incident.started_at)
                                                      )} mins
                                                      </i>
                                                    </span>
                                                ) : (
                                                    <i
                                                        className={`badge rounded-pill ${getStatusBadgeColor(incident.status)}`}
                                                        style={{
                                                          fontStyle: 'normal',
                                                          fontSize: '11px',
                                                          padding: '4px 8px',
                                                          marginBottom: '4px',
                                                          marginLeft: '10px',
                                                        }}
                                                    >
                                                      {incident.status}
                                                    </i>
                                                )}
                                              </div>
                                          ))}
                                        </div>
                                    ) : null}
                                    {hoveredTimelineData.alerts && hoveredTimelineData.alerts.length > 0 ? (
                                      <div className="mt-2">
                                        <div className="text-secondary mb-1">Alerts:</div>
                                        <ol style={{ 
                                          listStyleType: 'decimal',
                                          paddingLeft: '1.5rem',
                                          marginLeft: '1rem'
                                        }}>
                                          {hoveredTimelineData.alerts.map((alert, idx) => (
                                            <li key={`alert-${idx}`} className="mb-2">
                                              <div className="text-white">
                                                <span style={{ fontSize: '0.85rem' }}>{alert.name}</span>
                                                <i
                                                  className={`badge rounded-pill ${getSeverityBadgeColor(alert.severity)}`}
                                                  style={{
                                                    display: 'inline-block',
                                                    fontStyle: 'normal',
                                                    fontSize: '10px',
                                                    padding: '3px 6px',
                                                    marginBottom: '2px',
                                                    marginLeft: '8px'
                                                  }}
                                                >
                                                  {alert.severity}
                                                </i>
                                                <span className="text-white ms-1">
                                                  <i
                                                    className={`badge rounded-pill ${getStatusBadgeColor(alert.status)}`}
                                                    style={{
                                                      display: 'inline-block',
                                                      fontStyle: 'normal',
                                                      fontSize: '10px',
                                                      padding: '3px 6px',
                                                      marginBottom: '2px',
                                                      marginLeft: '4px',
                                                    }}
                                                  >
                                                    {alert.status} {alert.closed_at ? `- ${differenceInMinutes(
                                                    new Date(alert.closed_at),
                                                    new Date(alert.opened_at)
                                                  )} mins` : '- Ongoing'}
                                                  </i>
                                                </span>
                                              </div>
                                            </li>
                                          ))}
                                        </ol>
                                      </div>
                                    ) : null}
                                    {(!hoveredTimelineData.incidents || hoveredTimelineData.incidents.length === 0) &&
                                        (!hoveredTimelineData.alerts || hoveredTimelineData.alerts.length === 0) && (
                                        <div className="d-flex align-items-center gap-2 text-white mt-2">
                                          <i className="bx bx-check-circle" style={{ color: '#10B981', fontSize: '18px' }}></i>
                                          <span>No incidents or alerts reported</span>
                                        </div>
                                    )}
                                  </>
                              )}
                            </div>
                          </div>
                      )}
                      </div>
                  </div>
                <i
                  style={{marginLeft:"2%"}}
                  onClick={() => handleDeleteComponent(component.id)}
                  className='mdi mdi-delete text-danger font-size-20' />
              </div>
              ))}
          </div>
              ) : (
                <div className="text-center py-4">
                    <i className="bx bx-cog mb-2" style={{ color: '#6B7280', fontSize: '48px' }}></i>
                    <h6 className="text-white">No Services Added</h6>
                    <p className="text-secondary">Please create services before creating an incident</p>
                </div>
            )}
        </div>
        </div>
        <div className="card bg-transparent mb-1" style={{ background: 'None' }}>
          <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="text-white mb-0">Ongoing Incidents</h5>
                  <button
                      className="btn btn-primary"
                      onClick={() => navigate('/create-incident')}
                  >
                      Create Incident
                  </button>
              </div>
              {currentIncidents.length > 0 ? (
                  currentIncidents.map((incident) => (
                      <div key={incident.id} className="card bg-none mb-3" style={{ background: 'None' }}>
                          <div className="card-body">
                              <div
                                  className="d-flex justify-content-between align-items-start mb-2 cursor-pointer"
                                  style={{ cursor: 'pointer' }}
                              >
                                  <div style={{width:'90%'}}
                                       onClick={() => toggleExpand(incident.id)}
                                  >
                                      <div className="d-flex align-items-center gap-2">
                                          <h6
                                              className="text-white mb-1"
                                              style={{ fontSize: '1.1rem' }}
                                          >
                                              {incident.name}
                                          </h6>
                                          <i
                                            className={`badge rounded-pill ${getSeverityBadgeColor(incident.severity)}`}
                                            style={{
                                              fontStyle: 'normal',
                                              fontSize: '11px',
                                              padding: '4px 8px',
                                              marginBottom: '4px',
                                              marginLeft: '10px'
                                            }}
                                          >
                                            {incident.severity}
                                          </i>
                                          <i
                                              className={`badge rounded-pill ${getStatusBadgeColor(incident.status)}`}
                                              style={{
                                                  fontStyle: 'normal',
                                                  fontSize: '11px',
                                                  padding: '4px 8px',
                                                  marginBottom: '4px'
                                              }}
                                          >
                                              {incident.status}
                                          </i>
                                      </div>
                                      <small>Started: {getLocalDateTime(incident.started_at)}</small>
                                  </div>
                                <div style={{width: '10%'}}
                                     className='d-flex flex-row'>
                                  <Link
                                    to={`/incidents/${incident?.id}`}
                                    className="btn btn-secondary"
                                  >
                                    Update
                                  </Link>
                                  <i
                                    style={{marginLeft:"4%"}}
                                    onClick={() => handleDeleteIncident(incident.id)}
                                    className={'mdi mdi-delete text-danger font-size-20'}/>
                                </div>
                              </div>
                            <p className="text-white mb-3">{incident.description}</p>
                            {expandedCards[incident.id] && (
                                  <div className="expanded-content">
                                    <div className="mb-3">
                                      <h6 className="text-white mb-2">Affected Services:</h6>
                                      <div className="d-flex flex-wrap gap-2">
                                        {incident.affected_services.map((service, index) => (
                                            <div key={index}
                                                 className="d-flex align-items-center gap-2 border rounded px-2 py-1 text-white">
                                              <small>{service.component_name || service.application_service_name}</small>
                                            </div>
                                        ))}
                                      </div>
                                    </div>
                                    <div className="timeline-container border-start ps-3 ms-2">
                                      <h6 className="text-white mb-2">Incident Timeline</h6>
                                      {incident.history.map((event, index) => (
                                          <div key={index} className="timeline-item mb-3">
                                            <div className="d-flex flex-column">
                                              <small>{formatDate(event.timestamp)}</small>
                                              <div className="d-flex align-items-center gap-2 mt-1">
                                                  <span className={`badge ${getStatusBadgeColor(event.status)} px-2 py-1`}>
                                                      {event.status}
                                                  </span>
                                                <span className="text-white">{event.message}</span>
                                              </div>
                                            </div>
                                          </div>
                                      ))}
                                    </div>
                                  </div>
                              )}
                          </div>
                      </div>
                  ))
              ) : (
                  <div className="text-center py-4">
                      <i className="bx bx-check-circle mb-2" style={{ color: '#10B981', fontSize: '48px' }}></i>
                      <h6 className="text-white">Hurray! There are no incidents!!</h6>
                      <p className="text-secondary">All systems are operating normally</p>
                  </div>
              )}
          </div>
      </div>
      <div className="card bg-transparent" style={{ background: 'None' }}>
      <div className="card-body">
          <h5 className="text-white mb-4">Past Incidents</h5>
          {pastIncidents.length > 0 ? (
              pastIncidents.map((incident) => (
                  <div key={incident.id} className="card bg-none mb-3 d-flex flex-row" style={{ background: 'None' }}>
                      <div className="card-body">
                          <div
                              className="cursor-pointer"
                              onClick={() => toggleExpand(incident.id)}
                              style={{ cursor: 'pointer' }}
                          >
                              <div className="d-flex align-items-center mb-1">
                                  <h6
                                      className="text-white mb-0"
                                      style={{ fontSize: '1.1rem' }}
                                  >
                                      {incident.name}
                                  </h6>
                                  <i
                                      className={`badge rounded-pill ${getSeverityBadgeColor(incident.severity)}`}
                                      style={{
                                          fontStyle: 'normal',
                                          fontSize: '11px',
                                          padding: '4px 8px',
                                          marginLeft: '10px',
                                          marginBottom: '4px'
                                      }}
                                  >
                                      {incident.severity}
                                  </i>
                              </div>
                              <small>Started: {getLocalDateTime(incident.started_at)}</small>
                              <p className="text-white mt-2 mb-3">{incident.description}</p>
                              {expandedCards[incident.id] && (
                                  <div className="expanded-content">
                                      <div className="mb-3">
                                          <h6 className="text-white mb-2">Affected Services:</h6>
                                          <div className="d-flex flex-wrap gap-2">
                                              {incident.affected_services.map((service, index) => (
                                                  <div key={index} className="d-flex align-items-center gap-2 border rounded px-2 py-1 text-white">
                                                      <small>{service.component_name || service.application_service_name}</small>
                                                  </div>
                                              ))}
                                          </div>
                                      </div>
                                      <div className="timeline-container border-start ps-3 ms-2">
                                          <h6 className="text-white mb-2">Incident Timeline</h6>
                                          {incident.history.map((event, index) => (
                                              <div key={index} className="timeline-item mb-3">
                                                  <div className="d-flex flex-column">
                                                      <small>{formatDate(event.timestamp)}</small>
                                                      <div className="d-flex align-items-center gap-2 mt-1">
                                                          <span className={`badge ${getStatusBadgeColor(event.status)} px-2 py-1`}>
                                                              {event.status}
                                                          </span>
                                                          <span className="text-white">{event.message}</span>
                                                      </div>
                                                  </div>
                                              </div>
                                          ))}
                                      </div>
                                      {incident.ended_at && (
                                          <p className="text-white mt-2">Ended: {formatDate(incident.ended_at)}</p>
                                      )}
                                  </div>
                              )}
                          </div>
                      </div>
                    <div>
                      <i
                        style={{marginLeft:"2%"}}
                        onClick={() => handleDeleteIncident(incident.id)}
                        className='mdi mdi-delete text-danger font-size-20' />
                    </div>
                  </div>
              ))
          ) : (
              <div className="text-center py-4">
                  <i className="bx bx-history mb-2" style={{ color: '#6B7280', fontSize: '48px' }}></i>
                  <h6 className="text-white">No Past Incidents</h6>
                  <p className="text-secondary">No incident history to display</p>
              </div>
          )}
        </div>
      </div>
    </div>
      <Modal isOpen={showDeleteComponentModal}
             role="dialog"
             autoFocus={true}
             centered={true}
             className="exampleModal"
             tabIndex="-1">
        <div>
          <ModalHeader className="border-bottom-0">
            Are you sure you want to delete the component ?
          </ModalHeader>
        </div>
        <div className="modal-body">
          <div className="text-center mb-4">
            <div className="row justify-content-center">
              <div className="col-xl-10">
                <p className="mt-4">Once deleted you will not be able to see this component in your status page</p>
                <Row className="full-width">
                  <Col lg="6" className="mt-4">
                    <Link onClick={cancelDeleteComponent} className="btn btn-secondary w-md">Cancel</Link>
                  </Col>
                  <Col lg="6" className="mt-4">
                    <Link onClick={deleteComponent} className="btn btn-primary w-md">Delete</Link>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <Modal isOpen={showDeleteIncidentModal}
             role="dialog"
             autoFocus={true}
             centered={true}
             className="exampleModal"
             tabIndex="-1">
        <div>
          <ModalHeader className="border-bottom-0">
            Are you sure you want to delete the Incident ?
          </ModalHeader>
        </div>
        <div className="modal-body">
          <div className="text-center mb-4">
            <div className="row justify-content-center">
              <div className="col-xl-10">
                <p className="mt-4">Once deleted you will not be able to see this incident in your status page</p>
                <Row className="full-width">
                  <Col lg="6" className="mt-4">
                    <Link onClick={cancelDeleteIncident} className="btn btn-secondary w-md">Cancel</Link>
                  </Col>
                  <Col lg="6" className="mt-4">
                    <Link onClick={deleteTheIncident} className="btn btn-primary w-md">Delete</Link>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default StatusPageManagement;